import { call, put, takeLatest, all, cancelled } from "redux-saga/effects"
import axios from "axios"
import { generateTree, addLevel } from "../../../utils/utils"
import {
  GET_DIVISIONS_WATCHER,
  GET_DIMENSIONS_WATCHER,
  GET_TEAMS_WATCHER,
  GRAPHIC_BARS_WATCHER,
  GET_HISTORY_BY_TEAM_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
} from "./constants"

import {
  getDivisionsSuccess,
  getDimensionsSuccess,
  getTeamsSuccess,
  getTeamsWatcher,
  graphicBarsSuccess,
  graphicBarsFailed,
  getHistoryByTeamSuccess,
  getMeasureColorRangeSuccess,
  getQuestionsSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"

function getDimensionsApi(params) {
  let url = `reports/measure/${params.idMeasure}/dimensions`
  if (params.idDivision) {
    url = `reports/measure/${params.idMeasure}/leaders/${params.idDivision}/dimensions`
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: { id_segment: params.id_segment },
  })
}

function getTeamsApi(params) {
  const url = `reports/measure/${params.idMeasure}/dimensions`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: { id_segment: params.id_segment },
  })
}

function getQuestionsApi(params) {
  let url = `reports/measure/${params.idMeasure}/questions`
  if (params.idDivision) {
    url = `reports/measure/${params.idMeasure}/leaders/${params.idDivision}/questions?f`
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: { id_segment: params.id_segment },
  })
}

function getDivisionsApi(params) {
  const url = `reports/measure/${params.idMeasure}/leaders?f&recipients=true`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: { id_segment: params.id_segment },
  })
}

function getEvolutionHistoryByTeam(params) {
  const url = `reports/measure/${params.idMeasure}/evolution`
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: { id_segment: params.id_segment, id_position: params.idDivision },
  })
}

export function* getDivisionsSaga(params) {
  try {
    const [divsionsApi] = yield all([call(getDivisionsApi, params.payload)])
    const result = {}
    result.data = divsionsApi.data.data
    result.ifFirst = divsionsApi.data.is_first
    result.showHistory = divsionsApi.data.show_history
    yield put(getDivisionsSuccess(result))
  } catch (e) {
    console.log(
      "🚀 ~ file: saga.js ~ line 91 ~ function*getDivisionsSaga ~ e",
      e
    )
  }
}

export function* getHistoryByTeam(params) {
  try {
    const { data } = yield call(getEvolutionHistoryByTeam, params.payload)
    yield put(getHistoryByTeamSuccess(data))
  } catch (error) {
    returnMessage(error)
  }
}

function getReportMeasureInfoApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.idMeasure}/info`,
    params: { id_segment: params.id_segment },
  })
}

export function* getDimensionsSaga(action) {
  try {
    const [
      { data: dimensionsApi },
      { data: questionsApi },
      { data: measureInfo },
    ] = yield all([
      call(getDimensionsApi, action.payload),
      call(getQuestionsApi, action.payload),
      call(getReportMeasureInfoApi, action.payload),
    ])

    const dimensions = dimensionsApi.data
    const questions = questionsApi.data

    questions.map((e) => {
      return (e.id = parseInt(
        e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
      ))
    })

    const result = {
      metricTotal: dimensionsApi.metric_total,
      team: dimensionsApi.team,
      showHistory: dimensionsApi.show_history,
      switchMoreDimensions: dimensionsApi.switch,
      measureInfo: measureInfo.data,
    }

    result.dimensions = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensions)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    result.dimensions.forEach(addLevel(1))

    yield put(getQuestionsSuccess(questions))
    yield put(getDimensionsSuccess(result))
  } catch (e) {
    console.log(
      "🚀 ~ file: saga.js ~ line 144 ~ function*getDimensionsSaga ~ e",
      e
    )
  }
}

export function* getTeamsSaga(params) {
  try {
    const teamsApi = yield call(getTeamsApi, params.payload)

    const result = { data: teamsApi.data.data }

    yield put(getTeamsSuccess(result))
  } catch (e) {
    yield put(getTeamsWatcher({}))
  }
}

export function* graphicBarsSaga(action) {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "POST",
      endpoint: `reports/measure/${action.payload.idMeasure}/historical/comparative/chart`,
      data: action.payload.data,
      params: { id_segment: action.payload.id_segment },
    })

    yield put(graphicBarsSuccess(data))
  } catch (error) {
    yield put(graphicBarsFailed())
    returnMessage(error)
  }
}

// MEASURE COLOR RANGE
function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
  })
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getMeasureColorRangeSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Individual exports for testing
export default function* dimensionByTeamSaga() {
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
  yield takeLatest(GET_TEAMS_WATCHER, getTeamsSaga)
  yield takeLatest(GRAPHIC_BARS_WATCHER, graphicBarsSaga)
  yield takeLatest(GET_HISTORY_BY_TEAM_WATCHER, getHistoryByTeam)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  // See example in containers/HomePage/saga.js
}
